import { Seat, TransactionModel } from '@core/models';
import {
  ANALYTICS_ITEM_CATEGORIES,
  AnalyticsItem,
} from '@core/services/analytics';
import { buildCartItems } from '@features/pages/select-seat/_utils/cart-items.builder';

/**
 * Builds the items[] array for a persisted transaction: seat rows (one per section, via
 * cart-items.builder) plus an `upsell` row and a `rainout_insurance` row when active — so
 * add_payment_info / checkout_completed / purchase never drift onto different report rows.
 */
export function buildTransactionItems(
  transaction: TransactionModel,
  seats: Seat[]
): AnalyticsItem[] {
  const gameId = String(
    transaction.event?.pvEventId ?? transaction.eventId ?? ''
  );
  const matchup = transaction.event?.description ?? '';
  const items: AnalyticsItem[] = buildCartItems(seats, gameId, matchup);

  const upsell = transaction.event?.upsells?.find(
    candidate => candidate.buyerTypeId === transaction.buyerTypeId
  );
  if (upsell) {
    items.push({
      itemId: `upsell::${upsell.id}`,
      itemName: upsell.name,
      itemCategory: ANALYTICS_ITEM_CATEGORIES.UPSELL,
      price: upsell.price ?? undefined,
      quantity: 1,
    });
  }

  const tdcTransaction = transaction.tdcTransaction;
  if (tdcTransaction?.hasInsuranceRainout) {
    items.push({
      itemId: 'rainout_insurance',
      itemName: 'Rainout Insurance',
      itemCategory: ANALYTICS_ITEM_CATEGORIES.RAINOUT_INSURANCE,
      price: tdcTransaction.insuranceRainoutPrice ?? undefined,
      quantity: 1,
    });
  }

  return items;
}
